export const openAdvancePaymentBillTab = (applicationId) => {
    const query = applicationId
        ? `?applicationId=${encodeURIComponent(applicationId)}`
        : '';
    window.open(
        `${window.location.origin}/advance-payment-bill${query}`,
        '_blank',
        'noopener,noreferrer'
    );
};
